export const medium = '12px';
export const extraMedium = '8px';
export const small = '6px';
export const smaller = '3px';
